import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import YesNoQuestion from '../../../ui/advisory-flow/components/shared-components/YesNoQuestion';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import useMobileBreakpoints from '../../../../../../common/src/hooks/useMobileBreakpoints';
import QuestionGroupBody from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupBody';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';

interface Props {
  previousQuestionHandler: () => void;
  nextSubView: (arg0: string) => void;
}

const LicensePlateCheck: React.FC<React.PropsWithChildren<Props>> = ({
  previousQuestionHandler,
  nextSubView,
}) => {
  const { t } = useTranslation();
  const { isLaptop } = useMobileBreakpoints();

  return (
    <AdvisoryFlowMainContainer data-test-id="ProdFac_LicensePlateCheck">
      <QuestionGroupAssistantQuestion
        question={t('RISK-ANALYSIS_LICENSE-PLATE_DO-YOU-KNOW')}
        description={t('RISK-ANALYSIS_LICENSE-PLATE_DO-YOU-KNOW_DESC')}
      />

      <QuestionGroupBody>
        {isLaptop && (
          <YesNoQuestion
            handleYes={() => nextSubView('licensePlateSearch')}
            handleNo={() => nextSubView('vehicleSearch')}
          />
        )}
      </QuestionGroupBody>
      <QuestionGroupActions onBack={previousQuestionHandler} hideContinueButton>
        {!isLaptop && (
          <YesNoQuestion
            handleYes={() => nextSubView('licensePlateSearch')}
            handleNo={() => nextSubView('vehicleSearch')}
          />
        )}
      </QuestionGroupActions>
    </AdvisoryFlowMainContainer>
  );
};

export default LicensePlateCheck;
